import React, { PropTypes as p } from 'react'

import PinPreview from './pin-preview'
import MarkerIcon from './marker-icon'

import pinStatusColors from '../../helpers/pin-status-colors'

const PinMarker = ({
  pin,
  withPreview,
  className,
  onMouseOver,
  onMouseOut,
  ...rest
}) => (
  <div className={`pin-marker ${withPreview ? '-with-preview' : ''} ${className || 'up'}`} {...rest}>
    <PinPreview
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
      pin={pin}
      area={pin.area}
    />
    <MarkerIcon
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
      color={pinStatusColors[pin.status]}
    />
  </div>
)

PinMarker.propTypes = {
  pin: p.shape({ x: p.string, y: p.string, status: p.string }).isRequired,
  withPreview: p.bool,
  className: p.string,
  onMarkerMouseOver: p.func
}

export default PinMarker



// WEBPACK FOOTER //
// ./src/components/pins/pin-marker.js